export default __webpack_public_path__ + "static/media/prospects.3b709fc1.svg";